import React from 'react';
import './Research.css';

import Publications from '../Publications/Publications';
import Other from '../Other/Other';
import Posters from '../Publications/Posters';

const Education = function() {
    return (
        <div>
            <div className="space"/>
            <h2>
                EDUCATION
            </h2>
            <div className="space"/>

            <p>
            I received my PhD from the <a href="http://www.icmc.usp.br/" target="_blank"  rel="noopener noreferrer">Mathematical and Computer Sciences Institute (ICMC) </a>
            of <a href="http://www.saocarlos.usp.br/" target="_blank"  rel="noopener noreferrer">University of São Paulo (USP) - São Carlos</a>,
            SP, Brazil.
            I was a visiting researcher at the Aviz Group at INRIA in 2016-2017, and at NYU in 2015 for one month.
            <br />I got my MSc from the <a href="http://www.ucsp.edu.pe/" target="_blank"  rel="noopener noreferrer"> University of São Paulo (USP) - São Carlos </a>, SP, Brazil;
            and my BSc from the <a href="http://www.ucsp.edu.pe/" target="_blank"  rel="noopener noreferrer">San Pablo Catholic University</a>, Arequipa, Perú.
        </p>
        </div>
    );
}
const Research = function() {
  return (
      <div className="container">
        <div className="main-content">
            <Education/>
            <Publications/>
            <Posters/>
            <Other/>
        </div>
      </div>
  );
}

export default Research;



// WEBPACK FOOTER //
// ./src/Research/Research.js